import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipmentsEODPage',
    defaultMessage: 'Shipments > End of Day',
    id: '8PxPgT',
  },
});

export const hotkey = ['g', 'e'];
export const barcodeContent = '+9H4D3RMCZSQF=';

const GotoShipmentsEODPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/shipments/end-of-day'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['ge'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipmentsEODPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipmentsEODPage;
